module.exports = __webpack_public_path__ + "img/ic-lung.27f946b1.svg";